<template>
    <div class="ip-value-card">
        <AonCard title="IP Value">
            <div class="card-content">
                <div class="metric-holder display-flex">
                    <div class="half metric display-flex mr-md">
                        <div class="copy p-md w-100">
                            <p class="text-moat-900 bold mb-sm">Secondary Market Estimate</p>
                            <p>Computes value using comps from secondary IP market sales</p>
                        </div>
                        <div class="number p-md display-flex align-items-center justify-center">
                            <font-awesome-icon
                                v-if="!proUser"
                                icon="fas fa-lock"
                                :class="`text-on-dark`"
                                size="2x"
                            />
                            <p v-else-if="entityStore.ipValue" class="text-on-dark bold">
                                {{ entityStore.ipValue }}
                            </p>
                            <AonSpinner v-else :scale="0.3" color="white" />
                        </div>
                    </div>
                    <div class="half metric display-flex">
                        <div class="copy p-md w-100">
                            <p class="text-moat-900 bold mb-sm">Build/Buy - Cost to Re-Create</p>
                            <p>
                                Estimates value based on dollar cost to reproduce the research,
                                development, and expense to build the IP portfolio.
                            </p>
                        </div>
                        <div class="number p-md display-flex align-items-center justify-center">
                            <font-awesome-icon
                                v-if="!proUser"
                                icon="fas fa-lock"
                                :class="`text-on-dark`"
                                size="2x"
                            />
                            <p v-else-if="entityStore.ipRebuildCost" class="text-on-dark bold">
                                {{ entityStore.ipRebuildCost }}
                            </p>
                            <AonSpinner v-else :scale="0.3" color="white" />
                        </div>
                    </div>
                </div>
            </div>
        </AonCard>
    </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, inject, computed } from 'vue'
import { useEntityStore } from '@/stores'
import { useFlag } from '@unleash/proxy-client-vue'

import { useRoute } from 'vue-router'

const entityStore = useEntityStore()
const proUser = useFlag('alpha.AnalystPro')
const route = useRoute()
const entityId = route.params.targetPk

onMounted(async () => {
    if (proUser.value) {
        entityStore.getIpValue(entityId)
        entityStore.getIpRebuildCost(entityId)
    }
})

onBeforeUnmount(() => {})

const calcNumber = computed(() => {
    return false

    // Use this after we have pro users set up - BB

    // if (proUser.value) {
    //     // return entityStore.entity.ip_value ???
    // } else {
    //     return false
    // }
})
</script>

<style lang="scss" scoped>
.ip-value-card {
    width: 100%;
    position: relative;

    .half {
        width: 50%;
        min-height: 120px;
        border: 1px solid var(--color-stone-200);
    }

    .number {
        min-width: 80px;
        height: 100%;
        background: var(--color-moat-900);

        p {
            text-wrap: nowrap;
        }
    }

    .pro-banner {
        height: 200px;
        position: relative;
        overflow: hidden;

        .banner-img {
            width: 700px;

            position: absolute;
            top: -80px;
            right: 16px;
        }
    }
}
</style>
